import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStopNumberLookup extends Layout {
    sourceStopLookup: DataSource;
    table1: Table;
}
